// // import { useState, useEffect, useCallback } from "react";
// // import { PlusIcon, XMarkIcon } from "@heroicons/react/24/solid";
// // import TaskForm from "./TaskForm";
// // import TTableView from "./TTableView";

// // export default function SearchTaskForm() {
// //   const [showTaskForm, setShowTaskForm] = useState(false);
// //   const [refreshTable, setRefreshTable] = useState(false);

// //   const handleTaskCreated = () => {
// //     setShowTaskForm(false); // Close the modal
// //     setRefreshTable((prev) => !prev); // Trigger table refresh
// //   };

// //   // Close modal on ESC or Alt+C
// //   const handleKeyDown = useCallback(
// //     (event) => {
// //       if (
// //         event.key === "Escape" ||
// //         (event.altKey && (event.key.toLowerCase() === "c"))
// //       ) {
// //         setShowTaskForm(false);
// //       }
// //     },
// //     []
// //   );

// //   useEffect(() => {
// //     if (showTaskForm) {
// //       document.addEventListener("keydown", handleKeyDown);
// //     }
// //     return () => {
// //       document.removeEventListener("keydown", handleKeyDown);
// //     };
// //   }, [showTaskForm, handleKeyDown]);

// //   return (
// //     <>
// //       <div className="p-2 bg-gray-100 dark:bg-gray-900 rounded-lg shadow-lg">
// //         {/* Add Task Button */}
// //         <div className="flex justify-end items-center mx-2">
// //           <button
// //             type="button"
// //             onClick={() => setShowTaskForm(true)}
// //             className="flex items-center px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
// //           >
// //             <PlusIcon className="w-5 h-5 mr-2" />
// //             <span>Add Task</span>
// //           </button>
// //         </div>

// //         {/* Task Form Modal */}
// //         {showTaskForm && (
// //           <div
// //             className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4 sm:px-4 lg:px-4"
// //             role="dialog"
// //             aria-modal="true"
// //           >
// //             <div className="relative w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-3xl max-h-[90vh] bg-white dark:bg-gray-800 rounded shadow-2xl transition-all duration-300 transform scale-100 animate-fadeIn overflow-hidden flex flex-col">
// //               {/* Fixed Close Button */}
// //               <div className="sticky top-0 z-20 flex items-center justify-between bg-white dark:bg-gray-800 p-4 border-b border-gray-200 dark:border-gray-700">
// //                 <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
// //                   Add Task
// //                 </h2>
// //                 <button
// //                   onClick={() => setShowTaskForm(false)}
// //                   className="text-gray-500 hover:text-gray-700 dark:text-gray-300"
// //                   aria-label="Close modal"
// //                 >
// //                   <XMarkIcon className="w-6 h-6" />
// //                 </button>
// //               </div>
// //               {/* Scrollable Form Area */}
// //               <div className="custom-scroll px-5 sm:px-6 md:px-8 py-4">
// //                 <TaskForm
// //                   onClose={() => setShowTaskForm(false)}
// //                   onTaskCreated={handleTaskCreated}
// //                 />
// //               </div>
// //             </div>
// //           </div>
// //         )}

// //         {/* Table View */}
// //         <TTableView refreshTrigger={refreshTable} />
// //       </div>
// //     </>
// //   );
// // }










// import { useState, useEffect, useCallback } from "react";
// import { PlusIcon, XMarkIcon } from "@heroicons/react/24/solid";
// import TaskForm from "./TaskForm";
// import TTableView from "./TTableView";

// export default function SearchTaskForm() {
//   const [showTaskForm, setShowTaskForm] = useState(false);
//   const [refreshTable, setRefreshTable] = useState(false);

//   const handleTaskCreated = () => {
//     setShowTaskForm(false); // Close the modal
//     setRefreshTable((prev) => !prev); // Trigger table refresh
//   };

//   // Close modal on ESC or Alt+C
//   const handleKeyDown = useCallback(
//     (event) => {
//       if (
//         event.key === "Escape" ||
//         (event.altKey && (event.key.toLowerCase() === "c"))
//       ) {
//         setShowTaskForm(false);
//       }
//     },
//     []
//   );

//   useEffect(() => {
//     if (showTaskForm) {
//       document.addEventListener("keydown", handleKeyDown);
//     }
//     return () => {
//       document.removeEventListener("keydown", handleKeyDown);
//     };
//   }, [showTaskForm, handleKeyDown]);

//   return (
//     <>
//       <div className="p-2 bg-gray-100 dark:bg-gray-900 rounded-lg shadow-lg">
//         {/* Add Task Button */}
//         <div className="flex justify-end items-center mx-2">
//           <button
//             type="button"
//             onClick={() => setShowTaskForm(true)}
//             className="flex items-center px-2 py-1 bg-[#673AB7] text-white rounded-lg hover:bg-[#5e35a6] transition"
//           >
//             <PlusIcon className="w-5 h-5 mr-2" />
//             <span>Add Task</span>
//           </button>
//         </div>

//         {/* Task Form Modal */}
//         {showTaskForm && (
//           <div
//             className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4 sm:px-4 lg:px-4 animate-fade-in"
//             role="dialog"
//             aria-modal="true"
//           >
//             <div className="relative w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-3xl max-h-[90vh] bg-white dark:bg-gray-800 rounded-lg shadow-2xl transition-all duration-300 transform scale-100 animate-fadeIn overflow-hidden flex flex-col">
//               {/* Fixed Close Button */}
//               <div className="sticky top-0 z-20 flex items-center justify-between bg-white dark:bg-gray-800 p-4 border-b border-gray-200 dark:border-gray-700">
//                 <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
//                   Add Task
//                 </h2>
//                 <button
//                   onClick={() => setShowTaskForm(false)}
//                   className="text-gray-500 hover:text-gray-700 dark:text-gray-300"
//                   aria-label="Close modal"
//                 >
//                   <XMarkIcon className="w-6 h-6" />
//                 </button>
//               </div>
//               {/* Scrollable Form Area */}
//               <div className="custom-scroll px-5 sm:px-6 md:px-8 py-4">
//                 <TaskForm
//                   onClose={() => setShowTaskForm(false)}
//                   onTaskCreated={handleTaskCreated}
//                 />
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Table View */}
//         <TTableView refreshTrigger={refreshTable} />
//       </div>
//     </>
//   );
// }










import { useState, useEffect, useCallback } from "react";
import { PlusIcon, XMarkIcon } from "@heroicons/react/24/solid";
import TaskForm from "./TaskForm";
import TTableView from "./TTableView";

export default function SearchTaskForm() {
  const [showTaskForm, setShowTaskForm] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);

  const handleTaskCreated = () => {
    setShowTaskForm(false); // Close the modal
    setRefreshTable((prev) => !prev); // Trigger table refresh
  };

  // Close modal on ESC or Alt+C
  const handleKeyDown = useCallback(
    (event) => {
      if (
        event.key === "Escape" ||
        (event.altKey && (event.key.toLowerCase() === "c"))
      ) {
        setShowTaskForm(false);
      }
    },
    []
  );

  useEffect(() => {
    if (showTaskForm) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showTaskForm, handleKeyDown]);

  return (
    <>
      <div className="p-2 bg-gray-100 dark:bg-gray-900 rounded-lg shadow-lg font-sans antialiased">
        {/* Add Task Button */}
        <div className="flex justify-end items-center mx-2">
          <button
            type="button"
            onClick={() => setShowTaskForm(true)}
            className="flex items-center px-2 py-1 bg-[#673AB7] text-white rounded-lg hover:bg-[#5e35a6] transition font-medium"
          >
            <PlusIcon className="w-5 h-5 mr-2" />
            <span>Add Task</span>
          </button>
        </div>

        {/* Task Form Modal */}
        {showTaskForm && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4 sm:px-4 lg:px-4 animate-fade-in"
            role="dialog"
            aria-modal="true"
          >
            <div className="relative w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-3xl max-h-[90vh] bg-white dark:bg-gray-800 rounded-lg shadow-2xl transition-all duration-300 transform scale-100 animate-fadeIn overflow-hidden flex flex-col">
              {/* Fixed Close Button */}
              <div className="sticky top-0 z-20 flex items-center justify-between bg-white dark:bg-gray-800 p-4 border-b border-gray-200 dark:border-gray-700">
                <h2 className="text-xl font-medium text-gray-800 dark:text-white">
                  Add Task
                </h2>
                <button
                  onClick={() => setShowTaskForm(false)}
                  className="text-gray-500 hover:text-gray-700 dark:text-gray-300"
                  aria-label="Close modal"
                >
                  <XMarkIcon className="w-6 h-6" />
                </button>
              </div>
              {/* Scrollable Form Area */}
              <div className="custom-scroll px-5 sm:px-6 md:px-8 py-4">
                <TaskForm
                  onClose={() => setShowTaskForm(false)}
                  onTaskCreated={handleTaskCreated}
                />
              </div>
            </div>
          </div>
        )}

        {/* Table View */}
        <TTableView refreshTrigger={refreshTable} />
      </div>
    </>
  );
}



